import axios from 'axios';
const version =  ()=> {
    console.log(process.env.EVN_CONFIG);
    let d = (new Date()).getTime(); 
    let BASE_ROUTE =process.env.EVN_CONFIG == 'dev' ? '': process.env.BASE_ROUTE
    axios.get(`${BASE_ROUTE}/static/version.json?t=${d}`).then(response => {
        // console.log(response.data);
        refresh_verdict(response.data.version);
    }, response => {
        // console.log("error");
    });
}
version()
// let reload_count = 0


function refresh_verdict(server_version) {
    if (server_version == undefined) return;
    var cookie_name = '__version';
    var local_version = getCookie(cookie_name);
    // console.log("服务器端版本:" + server_version);
    // console.log("本地版本:" + local_version);
    // if (getCookie('reload_count') >= 1) {
    //     return clearCookie('reload_count');
    // }
    if (local_version == null || local_version == undefined || local_version == "" || server_version != local_version) {
        clearCookie(cookie_name)
        setCookie(cookie_name, server_version)
        // reload_count += 1
        // console.log(reload_count);
        // setCookie('reload_count', reload_count)
        location.reload(true); 
    }
}

//设置cookie
let setCookie = function (cname, cvalue, exdays) {
    if (exdays !== 0) {     //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    } else {
        document.cookie = cname + "=" + escape(cvalue);
    }

}
//获取cookie
let getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
//清除cookie
let clearCookie = function () {
    setCookie("username", "", -1);
}


// WEBPACK FOOTER //
// ./src/util/auto_refresh.js